<template>
  <div>
    <es-header>
      <template #header>
        <div class="header-title">
          Configuration Manager
        </div>
      </template>
    </es-header>
    <div class="tabs-container no-bottom-border">
      <es-tabs :tabs="availableTabs" ref="tabs"></es-tabs>
    </div>
  </div>
</template>

<script>
import EsHeader from '@/components/EsHeader.vue';
import PermissionManager from '@/mixins/PermissionManager';
import EsTabs from '@/components/EsTabs.vue';

export default {
  mixins: [
    PermissionManager,
  ],
  components: {
    EsHeader,
    EsTabs,
  },
  data() {
    return {
      tabs: [],
    };
  },
  created() {
    this.tabs = [
      {
        isAvailable: true,
        path: 'system',
        label: 'SYSTEM',
      },
      {
        isAvailable: this.hasModule('SYS:SYS:CONFIGMGR:PRSIDTAB') && this.hasModule('PRSID:APP:NAV:VIEW'),
        path: 'personId',
        label: 'PERSON ID',
      },
      {
        isAvailable: this.hasModule('SYS:SYS:CONFIGMGR:DRMCHTAB') && this.hasModule('DRMCH:APP:NAV:VIEW'),
        path: 'directMatch',
        label: 'DIRECTMATCH',
      },
      {
        isAvailable: this.hasModule('SYS:SYS:CONFIGMGR:DATAMARTTAB'),
        path: 'datamarts',
        label: 'DATA MARTS',
      },
      {
        isAvailable: this.hasModule('SYS:SYS:CONFIGMGR:SCHEDTAB'),
        path: 'schedule',
        label: 'SCHEDULE',
      },
      {
        isAvailable: this.hasModule('SYS:SYS:CONFIGMGR:INTEGRATIONTAB'),
        path: 'integration',
        label: 'INTEGRATION',
      },
    ];
  },
  computed: {
    availableTabs() {
      return this.tabs.filter(tab => tab.isAvailable);
    },
  },
};
</script>

<style lang="sass" scoped>
</style>
